import { Role } from '@guiker/permissions'

import { AdminRoleNames } from './role-names'

export const PayoutMethodReviewer: Role = {
  name: AdminRoleNames.PAYOUT_METHOD_REVIEWER,
  permissions: [{ action: 'payoutMethod:*' }],
}
